import { format } from 'date-fns';
import { ro } from 'date-fns/locale';

export const locationName = (l: any, withCity = false) => {
    const a = l.address;
    return `${l.name}, ${a?.street?.street_type?.name || ''} ${a?.street?.name || ''} ${a?.street_number || ''}${
        withCity ? `, ${a?.city?.name || ''}` : ''
    }`.trim();
};

export const selectedTimeSlotSummary = (date?: string, timeSlot?: string) => {
    return (
        date && (
            <>
                {format(new Date(date), 'EEEE, dd MMMM', { locale: ro })}
                {timeSlot ? `, ora ${timeSlot}` : ''}
            </>
        )
    );
};
